import { LocalStoredAuthData } from './Auth.types';

const init = async (): Promise<void> => {
  return Promise.resolve();
};

const getData = (): LocalStoredAuthData => {
  return {
    userName: 'Test User',
    email: 'test@example.com',
    token: 'mock-test-token-12345',
    markets: ['TEST_MARKET'],
    permissions: [
      'INSIGHTS_REVENUE_VIEW',
      'PROGRAMMATIC_DEAL_CREATE',
      'PROGRAMMATIC_DEAL_EDIT',
      'PROGRAMMATIC_DEAL_VIEW',
      'DIRECT_SALES_DEAL_CREATE',
      'DIRECT_SALES_DEAL_EDIT',
      'DIRECT_SALES_DEAL_VIEW',
      'CREATIVE_VIEW',
      'CREATIVE_EDIT',
      'CREATIVE_CREATE',
      'USER_MANAGEMENT_VIEW',
      'USER_MANAGEMENT_EDIT',
      'ROLE_MANAGEMENT_VIEW',
      'ROLE_MANAGEMENT_EDIT',
      'INVENTORY_VIEW',
      'INVENTORY_EDIT',
      'INSIGHTS_VIEW',
      'INSIGHTS_EDIT',
      'REVENUE_INSIGHTS_VIEW',
      'DEAL_HEALTH_VIEW',
      'PROOF_OF_PLAY_VIEW',
      'RESHUFFLE_VIEW',
      'RESHUFFLE_EDIT',
      'VISUAL_UNITS_VIEW',
      'VISUAL_UNITS_EDIT',
      'AVAILABILITY_REPORT_VIEW',
      'FRAMES_REPORT_VIEW',
      'PLANNER_VIEW',
      'PLANNER_EDIT',
      'NAVIGATION_PERMISSIONS',
      'PLANNERS_PERMISSIONS',
    ],
  };
};

const getToken = async (): Promise<string> => {
  return 'mock-test-token-12345';
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const redirectToUniversalLoginPage = async (_returnTo?: string): Promise<void> => {
  return Promise.resolve();
};

const isAuthenticated = (): boolean => {
  return true;
};

const hasPermission = (permission: string): boolean => {
  if (permission === 'FEATURE_FLAG_TIMEZONE_UTC') {
    return false;
  }

  const { permissions } = getData();
  return permissions.includes(permission);
};

const authenticate = async (): Promise<{ returnTo?: string }> => {
  const mockData = getData();
  localStorage.setItem('token', mockData.token || '');
  localStorage.setItem('markets', JSON.stringify(mockData.markets || []));
  localStorage.setItem('username', mockData.userName || '');
  localStorage.setItem('permissions', JSON.stringify(mockData.permissions || []));
  localStorage.setItem('email', mockData.email || '');

  return {};
};

const logout = (): void => {
  localStorage.removeItem('token');
  localStorage.removeItem('markets');
  localStorage.removeItem('username');
  localStorage.removeItem('permissions');
  localStorage.removeItem('email');
};

export default {
  init,
  redirectToUniversalLoginPage,
  isAuthenticated,
  hasPermission,
  authenticate,
  logout,
  getData,
  getToken,
};
